module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/banner/id-6a81f290941ba1ce1841fd82fceadaf5.jpg";